import { useTranslation } from 'next-i18next';
import { Fragment, RefObject, useEffect, useMemo, useState } from 'react';
import Link from 'next/link';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import styles from '@features/cms/components/collections/VoxboxWidget/VoxboxWidget.styles';
type PropsType = {
  hoverRef: RefObject<HTMLElement>;
  variant?: 'dark' | 'light';
  color?: string;
  small?: boolean;
  url?: string;
};
const VoxboxWidget = ({
  hoverRef,
  variant = 'light',
  color = '',
  small = false,
  url = ''
}: PropsType) => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);
  const {
    t
  } = useTranslation('common');
  const {
    t: tLayouts
  } = useTranslation('layouts');
  const styleColor = variant === 'dark' ? 'darkGrey700' : 'neutralWhite';
  const onEnter = () => {
    setIsHeadingVisible(true);
  };
  const onLeave = () => {
    setIsHeadingVisible(false);
  };
  useEffect(() => {
    const hoverElement = hoverRef.current;
    if (hoverElement) {
      hoverElement.addEventListener('mouseenter', onEnter);
      hoverElement.addEventListener('mouseleave', onLeave);
      return () => {
        hoverElement.removeEventListener('mouseenter', onEnter);
        hoverElement.removeEventListener('mouseleave', onLeave);
      };
    }
    return () => null;
  }, [hoverRef]);
  const memorizedIcon = useMemo(() => <Icon icon="Voxbox" size="40px" color={color || styleColor} />, [hoverRef]);
  return <Link href={url || '/pages/voxbox'} prefetch={false} sx={styles.headingContainer(isHeadingVisible, !!small)} target="_blank" title={`${small ? t('openRoomVoxBox') : t('designYourRoomVoxBox')} ${tLayouts('footer.links.opensInNewWindow')}`}>
      <div className="headingWrapper">
        <div sx={styles.icon}>{memorizedIcon}</div>
        <div className="headContainer">
          <Heading h={6} headingType={6} bold color={color || styleColor}>
            {small ? t('openRoomVoxBox').split('\n').map(smallText =>
          // @ts-expect-error - React 19 compatibility issue with Fragment types
          <Fragment key={smallText}>
                      {smallText} <br />
                    </Fragment>) : t('designYourRoomVoxBox')}
          </Heading>
        </div>
      </div>
    </Link>;
};
export default VoxboxWidget;